import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
// import { Renderer } from 'xlsx-renderer';

@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportDetailComponent implements OnInit {
  constructor(private http: HttpClient) {}

  title: string;

  excelHtml: string = '';

  ngOnInit(): void {}

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const arrayBuffer: any = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

      const firstSheetName: string = workbook.SheetNames[0];
      const worksheet: XLSX.WorkSheet = workbook.Sheets[firstSheetName];

      // const template = new Renderer();

      this.excelHtml = XLSX.utils.sheet_to_html(worksheet, {
        id: 'excel-sheet',
        editable: false,
        header: '',
      });
    };
    reader.readAsBinaryString(target.files[0]);
  }
}
